import React from "react";
import Card from "../../components/_contact/Card/Card";
import Layout from "../../shared/Layout/Layout";
import styles from "./Contact.module.scss";

const Contact = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.banner}>
            <div className={styles.overlay}></div>
            <h1>
              Contact <br /> us
            </h1>
          </div>

          <main className={styles.main}>
            <h1>Get in touch with us</h1>

            <Card />
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
